import { render, staticRenderFns } from "./mobile_about.vue?vue&type=template&id=1784b4c5&scoped=true&"
import script from "./mobile_about.vue?vue&type=script&lang=js&"
export * from "./mobile_about.vue?vue&type=script&lang=js&"
import style0 from "./mobile_about.vue?vue&type=style&index=0&id=1784b4c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1784b4c5",
  null
  
)

export default component.exports